import { render, staticRenderFns } from "./ImoFalForm2MenuGrid.vue?vue&type=template&id=c32217b6"
import script from "./ImoFalForm2MenuGrid.vue?vue&type=script&lang=js"
export * from "./ImoFalForm2MenuGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports